<template>
    <div>
        <v-btn rounded="lg" class="gradient-color-primary" prepend-icon="mdi-account-multiple-plus-outline" block @click="openChangeSlotsDialog">Slotanzahl anpassen</v-btn>
        <v-dialog class="agency-change-slots-dialog" v-model="handleChangeSlotsDialog" persistent>
            <v-card class="agency-change-slots-card" rounded="lg">
                <v-card-title class="agency-change-slots-card-title">Slotanzahl anpassen:</v-card-title>
                <v-card-text class="agency-change-slots-card-text">Passt die Slotanzahl in der Datenbank und bei Stripe an.</v-card-text>
                <v-text-field type="number" hide-details v-model="newAmountOfSlots" :label="`Aktuell: ${agency.amountSlots}`"></v-text-field>
                <v-divider class="agency-change-slots-divider"></v-divider>
                <div class="agency-change-slots-button-group">
                    <v-btn rounded="lg" :disabled="loading" color="error" @click="openChangeSlotsDialog">
                        Abbrechen
                    </v-btn>
                    <v-btn rounded="lg" :disabled="loading" class="gradient-color-primary" @click="changeAmountSlotsAndSaveLog">
                        Anpassen
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        agency: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            handleChangeSlotsDialog: false,
            newAmountOfSlots: null
        }
    },
    computed: {
        ...mapState('agency', ['loading']),
    },
    methods: {
        ...mapActions('agency', ['changeSlotAmount', 'saveLog']),
        openChangeSlotsDialog() {
            this.handleChangeSlotsDialog = !this.handleChangeSlotsDialog;
            this.newAmountOfSlots = null;
        },
        async changeAmountSlotsAndSaveLog() {
            const newAmountOfSlots = this.newAmountOfSlots;
            const updatedAgency = await this.$store.dispatch('agency/changeSlotAmount', { agencyId: this.agency._id, newAmountOfSlots: this.newAmountOfSlots, subID: this.agency.stripeSubscriptionInfo.subID });
            if (updatedAgency) {
                await this.$store.dispatch('agency/saveLog', {
                    agencyId: this.agency._id,
                    changes: [
                        {
                            date: new Date(),
                            description: `Amount Slots changed to ${newAmountOfSlots}.`,
                            user: this.$store.state.loginAndOut.name // Fetch the name of the admin from the state
                        }
                    ],
                });

            }
            this.openChangeSlotsDialog();
        }
    }
}
</script>

<style lang="scss" scoped>

.agency-change-slots-dialog {
    max-width: 600px;
    margin: 0 auto;
}

.agency-change-slots-card {
    padding: 12px;
}

.agency-change-slots-card-title {
    font-size: 20px;
    font-weight: 600;
    padding: 4px 4px 24px 4px;
}

.agency-change-slots-divider {
    margin: 32px 0 12px 0;
}

.agency-change-slots-button-group {
    display: flex;
    justify-content: end;
    gap: 8px;
}

.agency-change-slots-card-text {
    padding: 4px 4px 8px 4px !important;
    font-size: 14px;
    font-weight: 500;
}

</style>